import React, { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/TraQR_logo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import { MdArrowBackIos } from "react-icons/md";
import { useAuth } from "react-oidc-context";

const userMenuConfig = {
  admin: [
    // { to: "/user-profile", label: "User Profile", testId: "profile" },
    { to: "/activity_logs", label: "Activity Logs", testId: "activity_logs" },
    { to: "/payments", label: "Payments", testId: "payments" }
  ],
  customer: [
    { to: "/user-profile", label: "User Profile", testId: "user_profile" },
    { to: "/my-activity", label: "My Activity", testId: "activity_logs" },
    { to: "/subscription", label: "Subscription", testId: "subscriptions" },
    { to: "/payments", label: "Payments", testId: "payments" },
    { to: "/extra-credits", label: "Extra Credits", testId: "extra_credits" },
    { to: "/usage-tracker", label: "Usage Tracker", testId: "usage_tracker" },
  ],
};

const Navbar = ({ userRole, signOutRedirect }) => {
  const navbarCollapseRef = useRef(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [userName, setUserName] = useState(null);

  const auth = useAuth();

  useEffect(() => {
    const name = auth?.user?.profile?.name;
    setUserName(name);
  }, [auth]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = () => {
    const toggler = document.querySelector(".navbar-toggler");
    if (isMobile && toggler?.getAttribute("aria-expanded") === "true") {
      toggler.click();
    }
    setShowProfileMenu(false);
  };

  const toggleProfileMenu = () => {
    const toggler = document.querySelector(".navbar-toggler");
    if (isMobile && toggler?.getAttribute("aria-expanded") === "true") {
      toggler.click();
    }
    setShowProfileMenu((prev) => !prev);
  };

  const handleHamburgerClick = () => {
    if (showProfileMenu) setShowProfileMenu(false);
  };

  const renderAdminLinks = () => (
    <>
      <li className="nav-item">
        <NavLink
          to="/users"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Users</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          to="/subscription-plans"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Plans</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          to="/subscriptions"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Subscriptions</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          to="/print_collaterals"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Print Collaterals</span>
        </NavLink>
      </li>
    </>
  );

  const renderCustomerLinks = () => (
    <>
      <li className="nav-item custom-border-bottom ">
        <NavLink
          to="/campaigns"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="create-campaign-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Campaigns</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom ">
        <NavLink
          to="/contacts"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="upload-contacts-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Contacts</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/proof_templates"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="proof-template-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active"> Proof Templates</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/print_collaterals"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="print-collaterals-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active"> Print Collaterals</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="campaign-dashboard-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Dashboard</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <a
          href={process.env.REACT_APP_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link custom-nav-link"
          style={{
            display: "block",
          }}
          data-testid="contact-support-link"
          onClick={handleNavClick}
        >
          Support
          <i
            className="bi bi-box-arrow-up-right"
            style={{ marginLeft: "5px" }}
          ></i>
        </a>
      </li>
    </>
  );

  const renderUserMenuLinks = (links) =>
    links.map((link) => (
      <li key={link.to}>
        <NavLink
          to={link.to}
          className={({ isActive }) =>
            isActive ? "dropdown-item active" : "dropdown-item"
          }
          onClick={handleNavClick}
          data-testid={link.testId}
        >
          {link.label}
        </NavLink>
      </li>
    ));

  return (
    <nav className="navbar navbar-expand-lg fixed-top bg-white shadow-sm border-bottom custom-nav">
      <NavLink className="navbar-brand ms-2" to="/">
        <img src={logo} width="100" height="auto" alt="TraQR Logo" />
      </NavLink>

      <div className="d-flex align-items-center ms-auto me-2">
        <button
          className="navbar-toggler me-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleHamburgerClick}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {isMobile && (
          <button
            className="border-0 bg-transparent d-flex align-items-center gap-1 me-2"
            onClick={toggleProfileMenu}
          >
            <div className="profile-avatar">
              {userName ? userName.charAt(0).toUpperCase() : "U"}
            </div>
          </button>
        )}
      </div>

      <div
        className="collapse navbar-collapse custom-menu"
        id="navbarNavDropdown"
        ref={navbarCollapseRef}
      >
        <ul className="navbar-nav ms-3 ms-lg-auto me-2">
          {userRole === "admin" ? renderAdminLinks() : renderCustomerLinks()}

          {!isMobile && (
            <li className="nav-item custom-avatar">
              <button
                className="nav-link custom-nav-link border-0 bg-transparent d-flex align-items-center gap-1 custom-avatar"
                onClick={toggleProfileMenu}
              >
                <div className="profile-avatar">
                  {userName ? userName.charAt(0).toUpperCase() : "U"}
                </div>
              </button>
            </li>
          )}
        </ul>
      </div>

      {showProfileMenu && (
        <div
          className={`profile-overlay ${showProfileMenu ? "show" : ""}`}
          onClick={() => setShowProfileMenu(false)}
        ></div>
      )}

      {showProfileMenu && (
        <ul className={`profile-dropdown-menu ${showProfileMenu ? "open" : ""}`}>
          {!isMobile && (
            <li className="profile-header">
              <button className="btn btn-link p-0" onClick={() => setShowProfileMenu(false)}>
                <MdArrowBackIos size={20} />
              </button>
            </li>
          )}
          {userRole === "admin" ?
            renderUserMenuLinks(userMenuConfig.admin) :
            renderUserMenuLinks(userMenuConfig.customer)}
          <li>
            <button
              className="btn btn-danger"
              onClick={() => {
                signOutRedirect();
                setShowProfileMenu(false);
              }}
              data-testid="sign-out-button"
            >
              Sign Out
            </button>
          </li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
